import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
// eslint-disable-next-line no-restricted-imports
import { lighten, makeStyles } from '@material-ui/core/styles'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import PlusIcon from '@material-ui/icons/Add'
import { TbFaceId } from "react-icons/tb";
import { useSelector } from "react-redux";
import TablePagination from "@material-ui/core/TablePagination";
import EyeIcon from "@material-ui/icons/RemoveRedEye";
import { Badge } from "react-bootstrap";
import { MdRestartAlt } from "react-icons/md"
import { FcSynchronize } from "react-icons/fc"
import { AiOutlineFileSync } from "react-icons/ai"
import { BsCardHeading } from "react-icons/bs"
import { VscDebugRestartFrame } from "react-icons/vsc"
import {FaFingerprint} from "react-icons/fa"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Toolbar,
  Paper,
  Tooltip,
  CircularProgress,
} from '@material-ui/core'

const headRows = [
  {
    id: 'name',
    numeric: false,
    disablePadding: false,
    label: 'Qurğunun adı',
  },

  {
    id: 'syncOrder',
    numeric: false,
    disablePadding: false,
    label: 'Sinxronizasiya sırası ',
  },
  {
    id: 'appointment',
    numeric: false,
    disablePadding: false,
    label: 'Təyinat',
  },
  {
    id: 'devicePlace',
    numeric: false,
    disablePadding: false,
    label: 'Qurğu məkanı ',
  },
  {
    id: 'employeeCount',
    numeric: false,
    disablePadding: false,
    label: 'Qurğuya bağlı əməkdaş sayı ',
  },
  {
    id: 'fingerCount',
    numeric: false,
    disablePadding: false,
    label: 'Qurğuya bağlı barmaq izi sayı ',
  },
  {
    id: 'cardCount',
    numeric: false,
    disablePadding: false,
    label: 'Qurğuya bağlı kart sayı ',
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    label: 'Vəziyyət',
  },
  {
    id: 'tools',
    numeric: false,
    disablePadding: true,
    label: 'Əməliyyatlar',
  },
]

function EnhancedTableHead(props) {
  const { order,
    orderBy,
    onRequestSort, } = props

  return (
    <TableHead>
      <TableRow>
        {headRows.map((row) => (
          <TableCell
            key={row.id}
            align={row.numeric ? 'right' : 'left'}
            sortDirection={orderBy === row.id ? false : false}
          >
            <TableSortLabel active={orderBy === row.id}
              direction={order ? "asc" : "desc"}
              onClick={() => {
                return row.id !== "tools" ? onRequestSort(row.id) : null;
              }}>
              {row.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}


EnhancedTableHead.propTypes = {
  rowCount: PropTypes.number.isRequired,
  numSelected: PropTypes.number.isRequired,

};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    justifyContent: 'flex-end',
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },

  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
  dense: {
    margin: theme.spacing(2),
  },
}))

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles()
  const { numSelected, setShowCreate, permissionList } = props

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.actions}>
        {permissionList.some(element => element === "create_device") &&
          <Tooltip title="Əlavə et" placement="top">
            <button
              className="flex-shrink-0 btn btn-sm btn-icon btn-bg-light btn-text-primary btn-hover-primary mr-2 h5 rounded-circle flex-shrink-0"
              onClick={() => setShowCreate(true)}
            >
              <PlusIcon />
            </button>
          </Tooltip>}
      </div>
    </Toolbar>
  )
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  progresRoot: {
    width: '100%',
    padding: '32px 16px',
  },
  progress: {
    margin: 'auto',
    display: 'block',
    color: '#072C8C',
  },
}))

export default function EnhancedTable({
  devices,
  isLoading,
  setChooseDeviceId,
  setShowCreate,
  setShowRemove,
  setShowRemoveDevices,
  setShowEdit,
  deleteDevicesIds,
  setDeleteDevicesIds,
  isError,
  setSortField,
  setOrderByTable,
  sortField,
  orderBy,
  updateSkip,
  updateTake,
  count,
  filterInputsUpdate,
  filterInputs,
  setOpenView,
  setShowLogs,
  onRestartStatus,
  onSYNCStatus,
  onSYNCСardStatus,
  disabledSYNCCard,
  disabledRestart,
  disabledSYNC,
  disabledLog,
  onUpdateLog,
  disabledSYNCFinger,
  disabledSYNCFace,
  onSYNCFingerStatus,
  onSYNCFaceStatus,
}) {
  const classes = useStyles()
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const permissionList = useSelector(state => state.auth.permissionList)

  function handleRequestSort(property) {
    // const isDesc = sortField === property && !orderBy;
    const isDesc = sortField === property && orderBy === 'desc';


    // setOrderByTable(isDesc);
    setOrderByTable(isDesc ? 'asc' : 'desc');
    setSortField(property);
    updateTake(10);
    setRowsPerPage(10);
    updateSkip(0);
    setPage(0);
  }
  function handleSelectAllClick(event) {
    if (event.target.checked) {
      const newSelecteds = devices.map((n) => n.id)
      setDeleteDevicesIds(newSelecteds)
      return
    }
    setDeleteDevicesIds([])
  }
  function handleChangePage(event, newPage) {
    setPage(newPage);
    updateSkip(newPage);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(+event.target.value);
    updateTake(+event.target.value);
    setPage(0);
    updateSkip(0);
  }

  const isSelected = (id) => deleteDevicesIds.indexOf(id) !== -1

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        {isLoading && (
          <div className={classes.progresRoot}>
            <CircularProgress className={classes.progress} />
          </div>
        )}
        <EnhancedTableToolbar
          numSelected={deleteDevicesIds.length}
          setShowCreate={setShowCreate}
          setShowRemoveDevices={setShowRemoveDevices}
          permissionList={permissionList}
          filterInputsUpdate={filterInputsUpdate}
          filterInputs={filterInputs}
        />

        <div className={classes.tableWrapper}>
          {devices.length ? (
            <Table className={classes.table} aria-labelledby="tableTitle">
              <EnhancedTableHead
                numSelected={deleteDevicesIds.length}
                onSelectAllClick={handleSelectAllClick}
                rowCount={devices.length}
                order={orderBy}
                orderBy={sortField}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {devices.map((row, index) => {
                  const isItemSelected = isSelected(row.id)
                  const labelId = `enhanced-table-checkbox-${index}`
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                      selected={isItemSelected}
                    >
                      <TableCell component="th" id={labelId} scope="row">
                        {row.name ? row.name : "-"}
                      </TableCell>
                      <TableCell component="th" id={labelId} scope="row">
                        {row.syncOrder ? row.syncOrder : "-"}

                      </TableCell>
                      <TableCell component="th" id={labelId} scope="row">
                        {row.appointment ? row.appointment : "-"}
                      </TableCell>

                      <TableCell component="th" id={labelId} scope="row">
                        {row.devicePlace ? row.devicePlace : "-"}


                      </TableCell>

                      <TableCell component="th" id={labelId} scope="row">
                        {row.employeeCount ? row.employeeCount : "-"}

                      </TableCell>
                      <TableCell component="th" id={labelId} scope="row">
                        {row.fingerCount ? row.fingerCount : "-"}

                      </TableCell>

                      <TableCell component="th" id={labelId} scope="row">
                        {row.cardCount ? row.cardCount : "-"}

                      </TableCell>
                      <TableCell padding="default" className="pr-4 px-4">
                        <Badge
                          variant={
                            row.status === "OFFLINE"
                              ? "info"
                              : row.status === "ONLINE" ? "success" : "-"
                          }
                        >
                          {row.status === "OFFLINE"
                            ? "Ofline"
                            : row.status === "ONLINE" &&
                            "Online"}
                        </Badge>
                      </TableCell>

                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      // padding="none"
                      >
                        {permissionList.some(element => element === "restart_device") &&
                          <Tooltip title="Restart" placement="top">
                            <button
                              aria-label="restart"
                              className="btn btn-sm btn-icon  btn-bg-light btn-text-primary btn-hover-primary mr-2"
                              onClick={() => {
                                onRestartStatus(row.id);
                              }}

                              disabled={disabledRestart}
                            >
                              <MdRestartAlt style={{ height: "23px", width: "23px" }} />
                            </button>
                          </Tooltip>}
                        {permissionList.some(element => element === "sync_device") &&
                          <Tooltip title="SYNC" placement="top">
                            <button
                              aria-label="SYNC"
                              className="btn btn-sm btn-icon  btn-bg-light btn-text-warning btn-hover-warning mr-2"
                              onClick={() => {
                                onSYNCStatus(row.id);
                              }}
                              disabled={disabledSYNC}
                            >
                              <FcSynchronize style={{ height: "23px", width: "23px" }} />
                            </button>
                          </Tooltip>}
                        {permissionList.some(element => element === "sync_card_device") &&
                          <Tooltip title="Kart sinxronu" placement="top">
                            <button
                              aria-label="SYNC card"
                              className="btn btn-sm btn-icon  btn-bg-light btn-text-warning btn-hover-warning mr-2"
                              onClick={() => {
                                onSYNCСardStatus(row.id);
                              }}
                              disabled={disabledSYNCCard}
                            >
                              <VscDebugRestartFrame style={{ height: "20px", width: "20px" }} />
                            </button>
                          </Tooltip>
                        }
                        {row?.typeEnum == "FACE" && 
                          <Tooltip title="Üz sinxronu" placement="top">
                            <button
                              aria-label="SYNC face"
                              className="btn btn-sm btn-icon  btn-bg-light btn-text-warning btn-hover-warning mr-2"
                              onClick={() => {
                                onSYNCFaceStatus(row.id);
                              }}
                              disabled={disabledSYNCFace}
                            >
                              <TbFaceId style={{ height: "20px", width: "20px" }} />
                            </button>
                          </Tooltip>
                       } 
                        {permissionList.some(element => element === "sync_fingerprint_device") &&
                          <Tooltip title="Barmaq izi sinxronu" placement="top">
                            <button
                              aria-label="SYNC card"
                              className="btn btn-sm btn-icon  btn-bg-light btn-text-warning btn-hover-warning mr-2"
                              onClick={() => {
                                onSYNCFingerStatus(row.id);
                              }}
                              disabled={disabledSYNCFinger}
                            >
                              <FaFingerprint style={{ height: "20px", width: "20px" }} />
                            </button>
                          </Tooltip>
                        }

                        {permissionList.some(element => element === "view_log_from_device") &&
                          <Tooltip title="Loqlar " placement="top">
                            <button
                              aria-label="view"
                              className="btn btn-sm btn-icon btn-bg-light btn-text-info btn-hover-info mr-2"
                              onClick={() => {
                                setChooseDeviceId(row.id)
                                setShowLogs(true)
                              }}
                            >
                              <BsCardHeading style={{ width: "20px", height: "20px" }} />
                            </button>
                          </Tooltip>
                        }
                        {permissionList.some(element => element === "manual_log_from_device") &&
                          <Tooltip title="Loq yenilənməsi" placement="top">
                            <button
                              aria-label="Update logs"
                              className="btn btn-sm btn-icon  btn-bg-light btn-text-warning btn-hover-warning mr-2"
                              onClick={() => {
                                onUpdateLog(row.id);
                              }}
                              disabled={disabledLog}
                            >
                              <AiOutlineFileSync style={{ height: "23px", width: "23px" }} />
                            </button>
                          </Tooltip>
                        }

                        {permissionList.some(element => element === "edit_device") &&
                          <Tooltip title="Düzəliş et" placement="top">
                            <button
                              aria-label="edit"
                              className="btn btn-sm btn-icon btn-bg-light btn-text-dark btn-hover-dark mr-2"
                              onClick={() => {
                                setChooseDeviceId(row.id)
                                setShowEdit(true)
                              }}
                            >
                              <EditIcon />
                            </button>
                          </Tooltip>
                        }
                        {permissionList.some(element => element === "delete_device") &&

                          <Tooltip title="Sil" placement="top">
                            <button
                              aria-label="Delete"
                              className="btn btn-sm btn-icon btn-bg-light btn-text-danger btn-hover-danger  mr-2"
                              onClick={() => {
                                setChooseDeviceId(row.id)
                                setShowRemove(true)
                              }}
                            >
                              <DeleteIcon />
                            </button>
                          </Tooltip>}
                        {permissionList.some(element => element === "view_device") &&
                          <Tooltip title="Göstər" placement="top">
                            <button
                              aria-label="view"
                              className="btn btn-sm btn-icon btn-bg-light btn-text-info btn-hover-info mr-2"
                              onClick={() => {
                                setChooseDeviceId(row.id);
                                setOpenView();
                              }}
                            >
                              <EyeIcon />
                            </button>
                          </Tooltip>
                        }


                      </TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          ) : !devices.length && !isLoading && !isError ? (
            <div className="noInfo">
              <img
                src="/media/error/search.png"
                className="info-img"
                alt="information"
              />
              <h4>İnformasiya tapılmadı</h4>
            </div>
          ) : (
            !isLoading &&
            isError && (
              <div className="noInfo">
                <img
                  src="/media/error/connect.png"
                  className="info-img"
                  alt="connection"
                />
                <h4>Bağlantı yoxdur</h4>
              </div>
            )
          )}
        </div>

        {count > 10 && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}

            component="div"
            count={count}
            labelRowsPerPage={"Sətirlərin sayı"}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              "aria-label": "Əvvəlki səhifə",
            }}
            nextIconButtonProps={{
              "aria-label": "Növbəti səhifə",
            }}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />)}
      </Paper>
    </div>
  )
}
